import { ExternalLink, Gift, Star, TrendingUp } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'Casino Casino',
      url: 'https://www.casinocasino.com',
      bonus: '100% Bonus up to £100',
      icon: Gift,
      color: 'from-blue-600 to-blue-800',
      description: 'Double your first deposit instantly and kickstart your winning journey with this generous welcome package.',
    },
    {
      id: 2,
      name: 'Magic Red',
      url: 'https://www.magicred.com',
      bonus: '100% up to £35 + 50 spins',
      icon: Star,
      color: 'from-red-600 to-red-800',
      description: 'Get matched funds plus 50 free spins on premium slots. Perfect for players who want both cash and action.',
    },
    {
      id: 3,
      name: 'All British Casino',
      url: 'https://www.allbritishcasino.com/',
      bonus: 'Get 100% up to £100 + always 10% cashback',
      icon: TrendingUp,
      color: 'from-purple-600 to-purple-800',
      description: 'Not just a welcome bonus – enjoy ongoing 10% cashback on every bet. The gift that keeps on giving.',
    },
  ];

  return (
    <section id="offers" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-dark mb-4">
            Exclusive Casino Offers
          </h2>
          <p className="text-lg text-gray-light max-w-2xl mx-auto">
            Handpicked bonuses from trusted UK casinos. Each offer verified, 
            each bonus ready to claim. Your next big win starts here.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {offers.map((offer, index) => {
            const Icon = offer.icon;
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={offer.id}
                className={`bg-white rounded-xl shadow-lg overflow-hidden transition-all transform hover:scale-105 hover:shadow-2xl ${
                  isEven ? 'border-t-4 border-yellow-accent' : 'border-t-4 border-gray-medium'
                }`}
              >
                <div className={`bg-gradient-to-r ${offer.color} p-6 text-white`}>
                  <div className="flex items-center justify-between mb-4">
                    <Icon size={32} className="text-yellow-accent" />
                    <span className="bg-yellow-accent text-gray-dark px-3 py-1 rounded-full text-sm font-bold">
                      EXCLUSIVE
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold mb-2" itemProp="name">{offer.name}</h3>
                  <p className="text-gray-200 text-sm" itemProp="description">{offer.description}</p>
                </div>
                
                <div className="p-6">
                  <div className="mb-6">
                    <p className="text-sm text-gray-light mb-2">Welcome Bonus</p>
                    <p className="text-2xl font-bold text-gray-dark" itemProp="offers">{offer.bonus}</p>
                  </div>
                  
                  <a
                    href={offer.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow sponsored"
                    className="w-full bg-yellow-accent text-gray-dark py-3 px-6 rounded-lg font-bold hover:bg-yellow-light transition-colors flex items-center justify-center space-x-2"
                  >
                    <span>Play at {offer.name}</span>
                    <ExternalLink size={18} />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Offers;

